import { AnalyticsEventName } from '@dupe/common/constants'
import { ArrowRightIcon } from '@heroicons/react/24/solid'
import { useQRCode } from 'next-qrcode'
import Image from 'next/image'
import Link from 'next/link'
import useAnalytics from '~/src/hooks/useAnalytics'
import { cn } from '~/src/lib/utils'

interface Props extends React.HTMLProps<HTMLAnchorElement> {
  href: string
  label: string
  src?: string
  logo?: React.ReactNode
  qrCode?: boolean
  width?: number
  height?: number
  source?: string
  last?: boolean
}

const AppLink: React.FC<Props> = ({
  href,
  label,
  src,
  logo,
  qrCode,
  width,
  height,
  source,
  last,
  className,
}) => {
  const analytics = useAnalytics()
  const { Canvas } = useQRCode()

  return (
    <Link
      href={href}
      target='_blank'
      rel='noopener noreferrer'
      className={cn('group flex items-center justify-between py-4', className, {
        'border-b-2 border-b-black': !last,
      })}
      onClick={() => {
        analytics.track(AnalyticsEventName.AppLinkClicked, { label, source })
      }}
    >
      <div className='flex flex-1 items-center space-x-4'>
        <div>
          {src ? (
            <Image src={src} alt='' width={width} height={height} />
          ) : (
            logo
          )}
        </div>
        <div className='text-lg font-bold leading-tight md:text-xl'>
          {label}
        </div>
      </div>
      {!!qrCode ? (
        <div className='overflow-hidden rounded-lg border-2 border-black'>
          <Canvas
            text={href}
            options={{
              scale: 2,
              margin: 2,
            }}
          />
        </div>
      ) : (
        <div className='transition-transform group-hover:translate-x-2'>
          <ArrowRightIcon height={32} className='h-7 md:h-8' />
        </div>
      )}
    </Link>
  )
}

export default AppLink
